import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon54: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 16.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 16 20" width={width} height={height} {...props}>
      <Path
        d="M2.5 5.50045C2.5 2.26145 5.28403 -0.283555 8.53802 0.025445C11.358 0.294445 13.5 2.80545 13.5 5.71545V9.99145L13.991 9.99246C15.1 9.99246 16 10.8915 16 12.0005V16.0195C16 18.2135 14.221 19.9925 12.027 19.9925H3.97302C1.77902 19.9925 0 18.2135 0 16.0195V12.0005C0 10.8915 0.899972 9.99246 2.00897 9.99246L10.5 9.99145V5.49444C10.5 4.16944 9.469 3.08445 8.164 3.00045L8 2.99444C6.619 2.99444 5.5 4.11344 5.5 5.49444V6.50045C5.5 7.32845 4.828 8.00045 4 8.00045C3.172 8.00045 2.5 7.32845 2.5 6.50045V5.50045ZM13.991 10.9925L13.033 10.9914L13 10.9944C12.988 10.9944 12.977 10.9945 12.966 10.9935L11.033 10.9914L11 10.9944C10.988 10.9944 10.977 10.9945 10.966 10.9935L2.00897 10.9925C1.45197 10.9925 1 11.4435 1 12.0005V16.0195C1 17.6605 2.33102 18.9925 3.97302 18.9925H12.027C13.669 18.9925 15 17.6605 15 16.0195V12.0005C15 11.4435 14.548 10.9925 13.991 10.9925ZM8 12.9944C8.276 12.9944 8.5 13.2184 8.5 13.4944V16.4944C8.5 16.7704 8.276 16.9944 8 16.9944C7.724 16.9944 7.5 16.7704 7.5 16.4944V13.4944C7.5 13.2184 7.724 12.9944 8 12.9944ZM8.44397 1.02145C5.77697 0.767447 3.5 2.85045 3.5 5.50045V6.50045C3.5 6.77645 3.724 7.00045 4 7.00045C4.276 7.00045 4.5 6.77645 4.5 6.50045V5.49444C4.5 3.56144 6.067 1.99444 8 1.99444C9.933 1.99444 11.5 3.56144 11.5 5.49444V9.99145H12.5V5.71545C12.5 3.38045 10.841 1.36544 8.651 1.04644L8.44397 1.02145Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
